import { asText } from '@prismicio/helpers';

export function getMetaTitle(post: object) {
  if (post?.seo?.title) {
    return post?.seo?.title;
  }
  return getTitle(post);
}

export function getMetaDesc(post: object) {
  if (post?.meta?.description) {
    return post?.meta?.description;
  }
  const description = getDescription(post);
  return description.replace(/(<([^>]+)>)/gi, '');
}

export function getTitle(post: object) {
  if (post?.title) {
    return post?.title;
  } else if (post?.seo_title) {
    return post?.seo_title;
  }
  return null;
}

export function getDescription(post: object) {
  if (post?.meta?.description) {
    return post?.meta?.description;
  } else if (post?.summary) {
    return post?.summary;
  } else if (post?.excerpt?.richText) {
    return asText(post?.excerpt?.richText);
  } else if (post?.excerpt) {
    return post?.excerpt;
  }
  return null;
}

export function getFeaturedImage(post: object) {
  if (post?.feature_image?.url) {
    return post?.feature_image?.url;
  } else if (post?.image?.url) {
    return post?.image?.url;
  } else if (
    post?.featuredImage?.node?.localFile?.childImageSharp?.fluid?.src
  ) {
    return post?.featuredImage?.node?.localFile?.childImageSharp?.fluid?.src;
  }
  return null;
}

export function getSlug(post: object, type: string) {
  if (type === 'blog') {
    return `blog/${post?.slug?.replace(/^\/|\/$/g, '')}`;
  }
  return post?.slug?.replace(/^\/|\/$/g, '');
}
